<template>
  <div class="page">
    <div class="topLayout">
      <p class="titleLayout">
        <img src="./assets/img/gou.png" style="width:30px;margin-right:10px" alt="">{{detailGroup.name}}
      </p>
      <div class="buttonLayout">
        <div @click="uploadMaterialAction()" class="add">领队报账</div>
        <!-- <yd-button size="small" type="primary" @click.native="uploadMaterialAction()">上传材料</yd-button> -->
      </div>
      <div class="name" style="width:100%">
        {{detailGroup.activityName}}
      </div>
      <!-- <div class="price" style="width:100%">
        <span style="font-size:12px">¥</span>680
      </div> -->
    </div>
    <!-- <div class="singleLine"></div> -->
   <div class="barLine"></div>

    <yd-accordion accordion>
      <yd-accordion-item title="基础信息" open>
        <div class="singleLine"></div>
        <div class="textLayout">
          <p> <span>时间：</span> <span style="color:#333">{{getFormatDate(detailGroup.beginTime)}}&nbsp;至&nbsp;{{getFormatDate(detailGroup.endTime)}}</span></p>
          <p><span>组团地址：</span><span style="color:#333">{{detailGroup.startAddress}}</span></p>
          <p> <span>散团地址：</span> <span style="color:#333">{{detailGroup.endAddress}}</span></p>
          <p> <span>大人数量：</span> <span style="color:#333">{{detailGroup.adultCount}}</span></p>
          <p><span>小孩数量：</span> <span style="color:#333">{{detailGroup.childCount}}</span> </p>
          <p><span>陪同人员数量：</span> <span style="color:#333">{{detailGroup.accompCount}}</span></p>
          <!-- <p>应付金额：{{detailGroup.needPay}}元</p>  -->
          <!-- <p>已付金额：{{detailGroup.paid}}元</p> -->
        </div>
      </yd-accordion-item>
    </yd-accordion>
    <div class="barLine"></div>

    <yd-accordion :accordion="true">
      <yd-accordion-item :title="'指派导游' + (detailGroup.tourist.length == 0 ?'（未指派导游）':'')" open>
        <div class="singleLine"></div>
        <ul>
          <div v-for="(item,index) in detailGroup.tourist" :key="index" style="padding:0 15px;box-sizing:border-box">
            <li style="justify-content: space-between;padding: 5px 0px;box-sizing: border-box;display: flex; align-items: center;">
              <div class="right">
                <p style="font-size:16px;font-weight:500">{{item.name}}</p>
                <p style="font-size:12px;display: flex;align-items: center;line-height: 1.3;">手机号:<a :href="'tel:'+item.phone" style="color:#69d62f">{{item.phone}} </a></p>
              </div>
              <a :href="'tel:'+item.phone"><img src="./assets/img/tel.png"  alt="" style="width:20px;height:20px;margin-right:0px"></a>
              
            </li>
            <!-- <li>
                <div class="textLayout">
                  <p>姓名：{{item.name}}</p>
                  <p v-if="item.phone">手机号：
                      <a :href="'tel:'+item.phone" style="color:blue">{{item.phone}}</a>
                    </p>
                  <p>身份证号：{{item.idCard}}</p> 
                  <p>队员总数量：{{item.totalUser}}</p>
                  <p>上团日期：{{getFormatDate(item.startTime)}}</p>
                  <p>下团日期：{{getFormatDate(item.endTime)}}</p>
                  <p v-if="item.remark">备注：{{item.remark}}</p>
                </div>
                <div class="singleLine"></div>
                <div v-for="(person, idx) in item.users" :key="idx">
                  <li>
                    <div class="personSimpleCellLayout">
                      <div class="portraitSimpleLayout">
                        {{idx+1}}
                      </div>
                      <div class="nameSimpleLayout">       
                          <p>姓名：{{person.userName}}</p>
                          <p>性别：{{person.sex}}</p>
                          <p v-if="person.userPhone">手机号：
                            <a :href="'tel:'+person.userPhone" style="color:blue">{{person.userPhone}}</a>
                          </p>
                          <p>身份证号：{{person.idCard}}</p>
                      </div>
                    </div>
                  </li>
                  <div class="shiftSingleLine"></div>
                </div>
            </li> -->
            <!-- <div class="wideSingleLine"></div> -->
          </div>
        </ul>
      </yd-accordion-item>
    </yd-accordion>
    <div class="barLine"></div>

    <yd-accordion accordion>
      <yd-accordion-item title="游客名单" open>
        <div class="singleLine"></div>
        <ul>
          <div v-for="(person,index) in detailGroup.orders" :key="index">
            <li>
              <div class="personCellLayout">
                <!-- <div class="portraitLayout">
                  {{index+1}}
                </div> -->
                <div class="nameLayout" style="width:100%">       
                    <p style="display: flex;justify-content: space-between;"><span style="color:#999;font-size: 0.28rem;">姓名：</span> <span style="font-weight:500">{{person.userName}}</span> </p>
                    <!-- <p>性别：{{person.sex}}</p> -->
                    <p style="display: flex;justify-content: space-between;" v-if="person.userPhone">
                      <span style="color:#999;font-size: 0.28rem;">手机：</span><a :href="'tel:'+person.userPhone" style="color:#69d62f">{{person.userPhone}}</a>
                    </p>
                    <p style="display: flex;justify-content: space-between;"><span style="color:#999;font-size: 0.28rem;">证件：</span>{{person.idCard}}</p>
                    <!-- <p>年龄：{{person.age}}</p> -->
                    <!-- <p>订单号：{{person.tradeNo}}</p> -->
                    <p style="display: flex;justify-content: space-between;"><span style="color:#999;font-size: 0.28rem;">来源：</span>{{person.groupClubName}}</p>
                    <!-- <p v-if="person.groupClubPhone">组团社手机号：
                      <a :href="'tel:'+person.groupClubPhone" style="color:blue">{{person.groupClubPhone}}</a>
                    </p> -->
                    <!-- <p>报名时间：{{getFormatDate(person.createTime)}}</p> -->
                    <!-- <p>总金额：{{person.totalPrice}}元</p> -->
                    <!-- <p>应付金额：{{person.needPay}}元</p> -->
                    <!-- <p>已付金额：{{person.paid}}元</p> -->
                    <!-- <p v-if="parseExtraInfo(person.extra_info)">备注：{{parseExtraInfo(person.extra_info)}}</p> -->
                </div>
              </div>
            </li>
            <div class="singleLine"></div>
          </div>
        </ul>
      </yd-accordion-item>
    </yd-accordion>
    <div class="barLine"></div>

    <div v-if="!!detailGroup && detailGroup.fleet &&  detailGroup.fleet.length>0">
      <yd-accordion accordion>
        <yd-accordion-item title="车辆安排" open>
          <div class="singleLine"></div>
          <ul>
            <div v-for="(item,index) in detailGroup.fleet" :key="index">
              <li>
                <div class="textLayout">
                  <p><span>车队名称：</span> <span style="color:#333">{{item.name}}</span> </p>
                  <p> <span>用车时间：</span> <span style="color:#333">{{getFormatDate(item.startTime)}}&nbsp;至&nbsp;{{getFormatDate(item.endTime)}}</span> </p>
                  <p><span>驾驶员：</span> <span style="color:#333">{{item.driverName}}</span> </p>
                  <p><span>车牌号：</span> <span style="color:#333">{{item.carNo}}</span></p>
                  <p> <span>车辆类型：</span> <span style="color:#333">{{item.carType}}</span></p>
                  <p><span>联系方式：</span> <span style="color:#333">{{item.phone}}</span></p>
                  <p><span>价格：</span> <span style="color:#333">{{item.price}}元</span> </p>
                  <p v-if="item.fax"><span>传真：</span> <span style="color:#333">{{item.fax}}</span></p> 
                  <p v-if="item.landLine"><span>座机号码：</span> <span style="color:#333">{{item.landLine}}</span></p>
                  <p v-if="item.remark"><span>备注：</span> <span style="color:#333">{{item.remark}}</span></p>
                </div>
                <div class="singleLine"></div>
                  <div v-for="(person, idx) in item.users" :key="idx">
                    <li>
                      <div class="personSimpleCellLayout">
                        <div class="portraitSimpleLayout">
                          {{idx+1}}
                        </div>
                        <div class="nameSimpleLayout">       
                          <p>姓名：{{person.userName}}</p>
                          <p>性别：{{person.sex}}</p>
                          <p v-if="person.userPhone">手机号：
                            <a :href="'tel:'+person.userPhone" style="color:blue">{{person.userPhone}}</a>
                          </p>
                          <p>身份证号：{{person.idCard}}</p>
                        </div>
                      </div>
                    </li>
                  <div class="shiftSingleLine"></div>
                </div>
              </li>
              <div class="wideSingleLine"></div>
            </div>
          </ul>
        </yd-accordion-item>
      </yd-accordion>    
      <div class="barLine"></div>
    </div>

    <div v-if="!!detailGroup && detailGroup.hotel &&  detailGroup.hotel.length>0">
      <yd-accordion accordion >
        <yd-accordion-item title="酒店安排" open>
          <div class="singleLine"></div>
          <ul>
            <div v-for="(item,index) in detailGroup.hotel" :key="index">
              <li>
                <div class="textLayout">
                  <p> <span>酒店名称：</span> <span style="color:#333">{{item.name}}</span></p>
                  <p><span>住宿时间：</span> <span style="color:#333">{{getFormatDate(item.startTime)}}&nbsp;至&nbsp;{{getFormatDate(item.endTime)}}</span> </p>
                  <p><span>酒店地址：</span> <span style="color:#333">{{item.address}}</span></p>
                  <p><span>联系人：</span> <span style="color:#333">{{item.contact}}</span> </p>
                  <p><span>酒店电话：</span> <span style="color:#333">{{item.phone}}</span></p>
                  <p><span>单价：</span> <span style="color:#333">{{item.price}}元</span></p>
                  <p v-if="item.fax"><span>传真：</span> <span style="color:#333">{{item.fax}}</span></p> 
                  <p v-if="item.landLine"><span>座机号码：</span> <span style="color:#333"> {{item.landLine}}</span></p>
                  <p v-if="item.remark"><span> 备注：</span><span style="color:#333"> {{item.remark}}</span></p>
                </div>
                <div class="singleLine"></div>
                  <div v-for="(person, idx) in item.users" :key="idx">
                    <li>
                      <div class="personSimpleCellLayout">
                        <div class="portraitSimpleLayout">
                          {{idx+1}}
                        </div>
                        <div class="nameSimpleLayout">       
                          <p>姓名：{{person.userName}}</p>
                          <p>性别：{{person.sex}}</p>
                          <p v-if="person.userPhone">手机号：
                            <a :href="'tel:'+person.userPhone" style="color:blue">{{person.userPhone}}</a>
                          </p>
                          <p>身份证号：{{person.idCard}}</p>
                        </div>
                      </div>
                    </li>
                  <div class="shiftSingleLine"></div>
                </div>
              </li>
              <div class="wideSingleLine"></div>
            </div>
          </ul>
        </yd-accordion-item>
      </yd-accordion>
      <div class="barLine"></div>
    </div>
    
    <div v-if="!!detailGroup && detailGroup.insurance &&  detailGroup.insurance.length>0">
      <yd-accordion accordion>
        <yd-accordion-item title="保险安排" open>
          <div class="singleLine"></div>
          <ul>
            <div v-for="(item,index) in detailGroup.insurance" :key="index">
              <li>
                <div class="textLayout">
                  <p> <span>保险公司：</span>  <span style="color:#333">{{item.name}}</span></p>
                  <p> <span>保险有效期：</span> <span style="color:#333">{{getFormatDate(item.startTime)}}&nbsp;至&nbsp;{{getFormatDate(item.endTime)}}</span></p>
                  <p> <span>险种：</span> <span style="color:#333">{{item.insuranceType}}</span></p>
                  <p> <span>联系人：</span><span style="color:#333">{{item.contact}}</span></p>            
                  <p> <span>电话号码：</span> <span style="color:#333">{{item.phone}}</span> </p>
                  <p> <span>保费：</span> <span style="color:#333">{{item.price}}元</span></p>
                  <p v-if="item.fax"> <span>传真：</span> <span style="color:#333">{{item.fax}}</span></p> 
                  <p v-if="item.landLine"> <span>座机号码：</span> <span  style="color:#333">{{item.landLine}}</span></p>
                  <p v-if="item.remark"> <span>备注：</span> <span style="color:#333">{{item.remark}}</span></p>
                </div>
                <div class="singleLine"></div>
                  <div v-for="(person, idx) in item.users" :key="idx">
                    <li>
                      <div class="personSimpleCellLayout">
                        <div class="portraitSimpleLayout">
                          {{idx+1}}
                        </div>
                        <div class="nameSimpleLayout">       
                          <p>姓名：{{person.userName}}</p>
                          <p>性别：{{person.sex}}</p>
                          <p v-if="person.userPhone">手机号：
                            <a :href="'tel:'+person.userPhone" style="color:blue">{{person.userPhone}}</a>
                          </p>
                          <p>身份证号：{{person.idCard}}</p>
                        </div>
                      </div>
                    </li>
                  <div class="shiftSingleLine"></div>
                </div>
              </li>
              <div class="wideSingleLine"></div>
            </div>
          </ul>
        </yd-accordion-item>
      </yd-accordion>
      <div class="barLine"></div>
    </div>
    
    <div v-if="!!detailGroup && detailGroup.scenic &&  detailGroup.scenic.length>0">
      <yd-accordion accordion >
        <yd-accordion-item title="景区安排" open>
          <div class="singleLine"></div>
          <ul>
            <div v-for="(item,index) in detailGroup.scenic" :key="index">
              <li>
                <div class="textLayout">
                  <p><span>景区名称：</span> <span style="color:#333"> {{item.name}}</span></p>
                  <p><span>停留时间：</span> <span style="color:#333">{{getFormatDate(item.startTime)}}&nbsp;至&nbsp;{{getFormatDate(item.endTime)}}</span> </p>
                  <p><span>门票类型：</span> <span style="color:#333">{{item.ticketType}}</span> </p>
                  <p><span>联系人：</span> <span style="color:#333">{{item.contact}}</span> </p>            
                  <p><span>电话号码：</span> <span style="color:#333">{{item.phone}}</span> </p>
                  <p><span>底价：</span> <span style="color:#333">{{item.price}}元</span> </p>
                  <p v-if="item.fax"><span>传真：</span> <span style="color:#333">{{item.fax}}</span> </p> 
                  <p v-if="item.landLine"><span>座机号码：</span>  <span style="color:#333">{{item.landLine}}</span> </p>
                  <p v-if="item.remark"><span>备注：</span> <span style="color:#333">{{item.remark}}</span></p>
                </div>
                <div class="singleLine"></div>
                  <div v-for="(person, idx) in item.users" :key="idx">
                    <li>
                      <div class="personSimpleCellLayout">
                        <div class="portraitSimpleLayout">
                          {{idx+1}}
                        </div>
                        <div class="nameSimpleLayout">       
                          <p>姓名：{{person.userName}}</p>
                          <p>性别：{{person.sex}}</p>
                          <p v-if="person.userPhone">手机号：
                            <a :href="'tel:'+person.userPhone" style="color:blue">{{person.userPhone}}</a>
                          </p>
                          <p>身份证号：{{person.idCard}}</p>
                        </div>
                      </div>
                    </li>
                  <div class="shiftSingleLine"></div>
                </div>
              </li>
              <div class="wideSingleLine"></div>
            </div>
          </ul>
        </yd-accordion-item>
      </yd-accordion>
      <div class="barLine"></div>
    </div>

    <div v-if="!!detailGroup && detailGroup.visa &&  detailGroup.visa.length>0">
      <yd-accordion accordion>
        <yd-accordion-item title="签证安排" open>
          <div class="singleLine"></div>
          <ul>
            <div v-for="(item,index) in detailGroup.visa" :key="index">
              <li>
                <div class="textLayout">
                  <p><span>签证公司：</span> <span style="color:#333">{{item.name}}</span> </p>
                  <p><span>日期：</span> <span style="color:#333">{{getFormatDate(item.startTime)}}&nbsp;至&nbsp;{{getFormatDate(item.endTime)}}</span> </p>
                  <p><span>签证类型：</span> <span style="color:#333">{{item.visaType}}</span> </p>
                  <p><span>联系人：</span> <span style="color:#333">{{item.contact}}</span> </p>            
                  <p><span>电话号码：</span> <span style="color:#333">{{item.phone}}</span> </p>
                  <p><span>单价：</span> <span style="color:#333">{{item.price}}元</span> </p>
                  <p v-if="item.fax"><span>传真：</span> <span style="color:#333">{{item.fax}}</span> </p> 
                  <p v-if="item.landLine"><span>座机号码：</span> <span style="color:#333">{{item.landLine}}</span> </p>
                  <p v-if="item.remark"><span>备注：</span> <span style="color:#333">{{item.remark}}</span> </p>
                </div>
                <div class="singleLine"></div>
                  <div v-for="(person, idx) in item.users" :key="idx">
                    <li>
                      <div class="personSimpleCellLayout">
                        <div class="portraitSimpleLayout">
                          {{idx+1}}
                        </div>
                        <div class="nameSimpleLayout">       
                          <p>姓名：{{person.userName}}</p>
                          <p>性别：{{person.sex}}</p>
                          <p v-if="person.userPhone">手机号：
                            <a :href="'tel:'+person.userPhone" style="color:blue">{{person.userPhone}}</a>
                          </p>
                          <p>身份证号：{{person.idCard}}</p>
                        </div>
                      </div>
                    </li>
                  <div class="shiftSingleLine"></div>
                </div>
              </li>
              <div class="wideSingleLine"></div>
            </div>
          </ul>
        </yd-accordion-item>
      </yd-accordion>
      <div class="barLine"></div>
    </div>

    <div v-if="!!detailGroup && detailGroup.bigTraffic &&  detailGroup.bigTraffic.length>0">
      <yd-accordion accordion>
        <yd-accordion-item title="大交通安排" open>
          <div class="singleLine"></div>
          <ul>
            <div v-for="(item,index) in detailGroup.bigTraffic" :key="index">
              <li>
                <div class="textLayout">
                  <p><span>交通公司：</span> <span style="color:#333">{{item.name}}</span> </p>
                  <p><span>日期：</span> <span style="color:#333">{{getFormatDate(item.startTime)}}&nbsp;至&nbsp;{{getFormatDate(item.endTime)}}</span> </p>
                  <p><span>交通类别：</span> <span style="color:#333">{{item.trafficType}}</span> </p>
                  <p><span>始发地：</span> <span style="color:#333">{{item.startAddress}}</span> </p>
                  <p><span>目的地：</span> <span style="color:#333">{{item.endAddress}}</span> </p>
                  <p><span>班次：</span> <span style="color:#333">{{item.flightsNumber}}</span> </p>
                  <p><span>单价：</span> <span style="color:#333">{{item.price}}元</span> </p>
                  <p><span>联系人：</span> <span style="color:#333">{{item.contact}}</span> </p>            
                  <p><span>电话号码：</span> <span style="color:#333">{{item.phone}}</span> </p>
                  <p v-if="item.fax"><span>传真：</span> <span style="color:#333">{{item.fax}}</span> </p> 
                  <p v-if="item.landLine"><span> 座机号码：</span><span style="color:#333">{{item.landLine}}</span> </p>
                  <p v-if="item.remark"><span>备注：</span> <span style="color:#333">{{item.remark}}</span> </p>
                </div>
                <div class="singleLine"></div>
                  <div v-for="(person, idx) in item.users" :key="idx">
                    <li>
                      <div class="personSimpleCellLayout">
                        <div class="portraitSimpleLayout">
                          {{idx+1}}
                        </div>
                        <div class="nameSimpleLayout">       
                          <p>姓名：{{person.userName}}</p>
                          <p>性别：{{person.sex}}</p>
                          <p v-if="person.userPhone">手机号：
                            <a :href="'tel:'+person.userPhone" style="color:blue">{{person.userPhone}}</a>
                          </p>
                          <p>身份证号：{{person.idCard}}</p>
                        </div>
                      </div>
                    </li>
                  <div class="shiftSingleLine"></div>
                </div>
              </li>
              <div class="wideSingleLine"></div>
            </div>
          </ul>
        </yd-accordion-item>
      </yd-accordion>
      <div class="barLine"></div>
    </div>

    <div v-if="!!detailGroup && detailGroup.store &&  detailGroup.store.length>0">
      <yd-accordion accordion>
        <yd-accordion-item title="购物安排" open>
          <div class="singleLine"></div>
          <ul>
            <div v-for="(item,index) in detailGroup.store" :key="index">
              <li>
                <div class="textLayout">
                  <p><span>购物店：</span> <span style="color:#333">{{item.name}}</span> </p>
                  <p><span>日期：</span> <span style="color:#333">{{getFormatDate(item.startTime)}}&nbsp;至&nbsp;{{getFormatDate(item.endTime)}}</span></p>
                  <p><span>人头单价：</span> <span style="color:#333">{{item.price}}元</span> </p>
                  <p><span>返佣总额：</span> <span style="color:#333">{{item.total}}元</span> </p>
                  <p><span>导游：</span> <span style="color:#333">{{item.contact}}</span> </p>
                  <p><span>电话号码：</span> <span style="color:#333">{{item.phone}}</span> </p>
                  <p v-if="item.fax"><span> 传真：</span><span style="color:#333">{{item.fax}}</span> </p> 
                  <p v-if="item.landLine"><span>座机号码：</span> <span style="color:#333"> {{item.landLine}}</span></p>
                  <p v-if="item.remark"><span>备注：</span> <span style="color:#333">{{item.remark}}</span> </p>
                </div>
                <div class="singleLine"></div>
                  <div v-for="(person, idx) in item.users" :key="idx">
                    <li>
                      <div class="personSimpleCellLayout">
                        <div class="portraitSimpleLayout">
                          {{idx+1}}
                        </div>
                        <div class="nameSimpleLayout">       
                          <p>姓名：{{person.userName}}</p>
                          <p>性别：{{person.sex}}</p>
                          <p v-if="person.userPhone">手机号：
                            <a :href="'tel:'+person.userPhone" style="color:blue">{{person.userPhone}}</a>
                          </p>
                          <p>身份证号：{{person.idCard}}</p>
                        </div>
                      </div>
                    </li>
                  <div class="shiftSingleLine"></div>
                </div>
              </li>
              <div class="wideSingleLine"></div>
            </div>
          </ul>
        </yd-accordion-item>
      </yd-accordion>
      <div class="barLine"></div>
    </div>

    <div v-if="!!detailGroup && detailGroup.restaurant &&  detailGroup.restaurant.length>0">
      <yd-accordion accordion>
        <yd-accordion-item title="餐厅安排" open>
          <div class="singleLine"></div>
          <ul>
            <div v-for="(item,index) in detailGroup.restaurant" :key="index">
              <li>
                <div class="textLayout">
                  <p><span>餐厅名称：</span> <span style="color:#333">{{item.name}}</span> </p>
                  <p><span>日期：</span> <span style="color:#333">{{getFormatDate(item.startTime)}}&nbsp;至&nbsp;{{getFormatDate(item.endTime)}}</span> </p>
                  <p><span>单价：</span> <span style="color:#333">{{item.price}}元</span> </p>
                  <p><span>总额：</span> <span style="color:#333">{{item.total}}元</span> </p>
                  <p><span>联系人：</span> <span style="color:#333">{{item.contact}}</span> </p>
                  <p><span>电话号码：</span> <span style="color:#333">{{item.phone}}</span> </p>
                  <p v-if="item.fax"><span>传真：</span> <span style="color:#333">{{item.fax}}</span> </p> 
                  <p v-if="item.landLine"><span>座机号码：</span> <span style="color:#333">{{item.landLine}}</span> </p>
                  <p v-if="item.remark"><span>备注：</span> <span style="color:#333">{{item.remark}}</span> </p>
                </div>
                <div class="singleLine"></div>
                  <div v-for="(person, idx) in item.users" :key="idx">
                    <li>
                      <div class="personSimpleCellLayout">
                        <div class="portraitSimpleLayout">
                          {{idx+1}}
                        </div>
                        <div class="nameSimpleLayout">       
                          <p>姓名：{{person.userName}}</p>
                          <p>性别：{{person.sex}}</p>
                          <p v-if="person.userPhone">手机号：
                            <a :href="'tel:'+person.userPhone" style="color:blue">{{person.userPhone}}</a>
                          </p>
                          <p>身份证号：{{person.idCard}}</p>
                        </div>
                      </div>
                    </li>
                  <div class="shiftSingleLine"></div>
                </div>
              </li>
              <div class="wideSingleLine"></div>
            </div>
          </ul>
        </yd-accordion-item>
      </yd-accordion>
      <div class="barLine"></div>
    </div>

    <div v-if="!!detailGroup && detailGroup.selfPay &&  detailGroup.selfPay.length>0">
      <yd-accordion accordion>
        <yd-accordion-item title="自费支出" open>
          <div class="singleLine"></div>
          <ul>
            <div v-for="(item,index) in detailGroup.selfPay" :key="index">
              <li>
                <div class="textLayout">
                  <p><span>自费项目：</span> <span style="color:#333">{{item.name}}</span> </p>
                  <p><span> 日期：</span><span style="color:#333">{{getFormatDate(item.startTime)}}&nbsp;至&nbsp;{{getFormatDate(item.endTime)}}</span> </p>
                  <p><span>单价：</span> <span style="color:#333">{{item.price}}元</span> </p>
                  <p><span>总额：</span> <span style="color:#333">{{item.total}}元</span> </p>
                  <p><span>联系人：</span> <span style="color:#333"> {{item.contact}}</span></p>
                  <p><span>电话号码：</span> <span style="color:#333">{{item.phone}}</span> </p>
                  <p v-if="item.fax"><span>传真：</span> <span style="color:#333">{{item.fax}}</span> </p> 
                  <p v-if="item.landLine"><span>座机号码：</span> <span style="color:#333">{{item.landLine}}</span> </p>
                  <p v-if="item.remark"><span>备注：</span> <span style="color:#333">{{item.remark}}</span> </p>
                </div>
                <div class="singleLine"></div>
                  <div v-for="(person, idx) in item.users" :key="idx">
                    <li>
                      <div class="personSimpleCellLayout">
                        <div class="portraitSimpleLayout">
                          {{idx+1}}
                        </div>
                        <div class="nameSimpleLayout">       
                          <p>姓名：{{person.userName}}</p>
                          <p>性别：{{person.sex}}</p>
                          <p v-if="person.userPhone">手机号：
                            <a :href="'tel:'+person.userPhone" style="color:blue">{{person.userPhone}}</a>
                          </p>
                          <p>身份证号：{{person.idCard}}</p>
                        </div>
                      </div>
                    </li>
                  <div class="shiftSingleLine"></div>
                </div>
              </li>
              <div class="wideSingleLine"></div>
            </div>
          </ul>
        </yd-accordion-item>
      </yd-accordion>
      <div class="barLine"></div>
    </div>  

    <div v-if="!!detailGroup && detailGroup.otherPay &&  detailGroup.otherPay.length>0">
      <yd-accordion accordion>
        <yd-accordion-item title="其他支出" open>
          <div class="singleLine"></div>
          <ul>
            <div v-for="(item,index) in detailGroup.otherPay" :key="index">
              <li>
                <div class="textLayout">
                  <p><span>支出项目：</span> <span style="color:#333">{{item.name}}</span> </p>
                  <p><span>日期：</span> <span style="color:#333">{{getFormatDate(item.startTime)}}&nbsp;至&nbsp;{{getFormatDate(item.endTime)}}</span> </p>
                  <p><span>单价：</span> <span style="color:#333">{{item.price}}元</span> </p>
                  <p><span>总额：</span> <span style="color:#333">{{item.total}}元</span> </p>
                  <p><span>联系人：</span> <span style="color:#333">{{item.contact}}</span> </p>
                  <p><span>电话号码：</span> <span style="color:#333">{{item.phone}}</span> </p>
                  <p v-if="item.fax"><span>传真：</span> <span style="color:#333"> {{item.fax}}</span></p> 
                  <p v-if="item.landLine"><span>座机号码：</span> <span style="color:#333">{{item.landLine}}</span> </p>
                  <p v-if="item.remark"><span>备注：</span> <span style="color:#333">{{item.remark}}</span> </p>
                </div>
                <div class="singleLine"></div>
                  <div v-for="(person, idx) in item.users" :key="idx">
                    <li>
                      <div class="personSimpleCellLayout">
                        <div class="portraitSimpleLayout">
                          {{idx+1}}
                        </div>
                        <div class="nameSimpleLayout">       
                          <p>姓名：{{person.userName}}</p>
                          <p>性别：{{person.sex}}</p>
                          <p v-if="person.userPhone">手机号：
                            <a :href="'tel:'+person.userPhone" style="color:blue">{{person.userPhone}}</a>
                          </p>
                          <p>身份证号：{{person.idCard}}</p>
                        </div>
                      </div>
                    </li>
                  <div class="shiftSingleLine"></div>
                </div>
              </li>
              <div v-if="index < otherPay.length-1" class="wideSingleLine"></div>
            </div>
          </ul>
        </yd-accordion-item>
      </yd-accordion>
      <div class="barLine"></div>
    </div>    

    <div v-if="!!detailGroup && detailGroup.vouchers &&  detailGroup.vouchers.length>0">
      <yd-accordion accordion>
        <yd-accordion-item title="费用报销" open>
          <div class="singleLine"></div>
          <ul>
            <div v-for="(item,index) in vouchers" :key="index">
              <li>
                <div class="textLayout">
                  <p><span>报销项目：</span> <span style="color:#333">{{item.title}}</span> </p>
                  <p><span> 提交日期：</span><span style="color:#333">{{getFullFormatDate(item.createTime)}}</span></p>
                  <p><span>费用：</span> <span style="color:#333">{{item.price}}元</span></p>
                  <p><span>备注：</span> <span style="color:#333">{{item.remark}}元</span></p>
                </div>
                <div class="singleLine"></div>
                  <div v-for="(imageUrl, idx) in JSON.parse(item.imagePath)" :key="idx">
                    <li>
                      <img style="width:100%;object-fit:cover;padding:12px" v-lazy="imageUrl">
                    </li>
                </div>
              </li>
              <div style="height:40px">
                <yd-button style="position:absolute;width:60px;right:12px;margin-right:2px;color:red" size="small" type="hollow" @click.native="deleteVoucherAction(index)">删除</yd-button>
              </div>
              <div v-if="index < vouchers.length-1" class="wideSingleLine"></div>
            </div>
          </ul>
        </yd-accordion-item>
      </yd-accordion>
    </div>
  </div>
</template>

<script>
import appService from '@/services/request/appService'
import store from 'store'
export default {
  name: "ScheduleTourist",
  data() {
    return {
      mine:{},
      dateTime:'',
      currentDate:'',
      pageNo:1,
      index: this.$route.query.index,
      group:{},
      users:[], //游客
      tourist:[], //导游
      fleet:[], //车辆
      hotel:[], //酒店
      insurance:[], //保险
      scenic:[], //景区
      visa:[], //签证
      bigTraffic:[], //大交通
      store:[], //购物
      restaurant:[], //餐厅
      selfPay:[], //自费
      otherPay:[], //其他支出
      vouchers:[], //费用报销,
      detailGroup:''
    }
  },
  mounted() {
    this.$nextTick(function(){
      document.title = "开团信息"
      this.mine = store.get('mine') || {}
      this.loadStoreData()
      this.loadDetail()
    })    
  },
  methods: {
    loadStoreData() {
      var touristArray = store.get('organizeTourData')
      var groupData = {}
      if(touristArray && touristArray.length > 0) {        
        groupData = touristArray[this.index]
        if(groupData) {
          this.group = groupData
          if(groupData.users && groupData.users.length>0) this.users = JSON.parse(groupData.users)
          if(groupData.tourist && groupData.tourist.length>0) this.tourist = JSON.parse(groupData.tourist)
          if(groupData.fleet && groupData.fleet.length>0) this.fleet = JSON.parse(groupData.fleet)
          if(groupData.hotel && groupData.hotel.length>0) this.hotel = JSON.parse(groupData.hotel)
          if(groupData.insurance && groupData.insurance.length>0) this.insurance = JSON.parse(groupData.insurance)
          if(groupData.scenic && groupData.scenic.length>0) this.scenic = JSON.parse(groupData.scenic)
          if(groupData.visa && groupData.visa.length>0) this.visa = JSON.parse(groupData.visa)
          if(groupData.bigTraffic && groupData.bigTraffic.length>0) this.bigTraffic = JSON.parse(groupData.bigTraffic)
          if(groupData.store && groupData.store.length>0) this.store = JSON.parse(groupData.store)
          if(groupData.restaurant && groupData.restaurant.length>0) this.restaurant = JSON.parse(groupData.restaurant)
          if(groupData.selfPay && groupData.selfPay.length>0) this.selfPay = JSON.parse(groupData.selfPay)
          if(groupData.otherPay && groupData.otherPay.length>0) this.otherPay = JSON.parse(groupData.otherPay)
          if(groupData.vouchers && groupData.vouchers.length>0) this.vouchers = JSON.parse(groupData.vouchers)
        }
        setTimeout(() => {
          this.updateCommpontsStyle()  
        }, 100);
        
      }
    },
    async loadDetail(){
      
      let res = await   appService.getGroupDetail({
                  iid: this.$route.query.iid, 
                  id:this.$route.query.id,
                  saleIid:this.$route.query.saleIid?this.$route.query.saleIid:''
                })
       console.log('res,res',res)
       if(!!res.vouchers){
         res.vouchers = JSON.parse(res.vouchers)
       }
       this.detailGroup = res
      //  document.title =  this.detailGroup.name + "开团信息"
      
    },
    parseExtraInfo(jsonString) {
      var jsonDic = JSON.parse(jsonString)
      var infoString = ''
      for( var key in jsonDic) {
        if(jsonDic[key]) {
          infoString += jsonDic[key] + '  '
        }
      }
      console.log('parseExtraInfo:'+infoString)
      return infoString
    },
    getFormatDate(timeStamp) {
      var date = new Date(timeStamp);
      var seperator = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (day >= 0 && day <= 9) {
        day = "0" + day;
      }
      var dateStr = year + seperator + month + seperator + day;
      return dateStr;
    },
    getFullFormatDate(timeStamp) {
      var date = new Date(timeStamp);
      var seperator = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      if (month >= 1 && month <= 9)   month = "0" + month;
      var day = date.getDate();
      if (day >= 0 && day <= 9)   day = "0" + day;
      var hour = date.getHours();
      if(hour >=0 && hour <= 9)   hour = "0" + hour
      var minute = date.getMinutes();
      if(minute >=0 && minute <= 9)   minute = "0" + minute
      var second = date.getSeconds();
      if(second >=0 && second <= 9)   second = "0" + second
      var dateStr = year + seperator + month + seperator + day + "    " + hour + ":" + minute + ":" + second;
      return dateStr;
    },
    uploadMaterialAction() {
      // this.$router.push({
      //   path: '/m/schedule/material',
      //   query: {
      //     groupId:this.group.id,
      //     iid:this.$route.query.iid
      //   }
      // })
      this.$router.push({
        path:'/m/schedule/voucherist',
        query:{
          index:this.$route.query.index,
          id:this.$route.query.id,
          iid:this.$route.query.iid
        }
      })
    },
    deleteVoucherAction(index) {
      var newArray = []
      this.vouchers.forEach(function(e,i) {
        newArray.push(e)
      })        
      newArray.splice(index,1)
      appService.updateMaterial({
          id: this.group.id,
          vouchers: JSON.stringify(newArray),
          iid: this.$route.query.iid,
          saleIid:this.$route.query.saleIid?this.$route.query.saleIid:''
        })
        .then(data => {
          this.$dialog.toast({
            mes: '删除成功',
            timeout: 1500,
            icon: 'success',
          });
          this.vouchers.splice(index,1)
        }, error => {
          this.$dialog.toast({
            mes: '删除失败',
            timeout: 1500,
            icon: 'error',
          });
        })
    },
    updateCommpontsStyle() {
      var elements = window.document.getElementsByTagName('span')
      for(var i = 0; i < elements.length; i++) {
        var el = elements[i]
        if(el.innerHTML != '上传材料') {
          const styleObj = el.style
          styleObj.setProperty('font-size', '0.28rem');
        }
      }
    }
  },
};
</script>

<style scoped lang="less">
.yd-accordion-title{
  font-size: 0.28rem;
  font-size: 500;
}
.page {
  font-size: 0.28rem;
  // margin-bottom: -0.5rem;
  overflow: hidden;
  padding:10px;
  box-sizing: border-box;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  & /deep/ .yd-accordion-title{
    font-size: 0.28rem;
    span{
        font-size: 0.28rem;
        font-weight: 500;
    }
  }
}
.topLayout{
  width: 100%;
  display: flex;
  background-color: white;
  flex-wrap: wrap;
  border-radius: 5px;
  .name{
    font-weight: 500;
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;
    font-size: 14px;
    color: #65cb29;
    padding-bottom: 15px;
    box-sizing: border-box;
  }
  .price{
    font-weight: 500;
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;
    font-size: 14px;
    color: #fc7905;
  }
}
.topLayout .titleLayout{
  float: left;
  color: #333;
  padding: 12px;
  padding-right: 0px;
  width: 65%;
  background-color: white;
  font-weight:bold;
  font-size:18px;
  margin: auto 0px;
  vertical-align: middle;
  /* justify-content: center; */
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.topLayout .buttonLayout{
  float: right;
  text-align: right;
  padding: 12px;
  // margin-right: 0px;
  font-size: 12px;
  background: none;
  box-sizing: border-box;
  width: 35%;
  .add{
    width: 100px;
    height: 35px;
    border: 2px solid #69d62f;
    color: #69d62f;
    border-radius: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
  }
}
.textLayout{
  color: #666;
  padding: 12px;
  background-color: white;
  font-size:14px;
  p{
    line-height: 25px;
    display: flex;
    justify-content: space-between;
  }
  & /deep/ .yd-accordion-title{
    font-size: 0.28rem;
    span{
        font-size: 0.28rem;
        font-weight: 500;
    }
  }
}
.personCellLayout{
  display: flex;
  padding: 6px 16px 6px 12px;
  background-color: white;
}
.personCellLayout .portraitLayout{
  float: left;
  vertical-align: center;
  justify-content: center;
  width: 20%;
  margin: auto;
  text-align: center;
  font-size: 0.50rem;
  color: #64b572;
}
.personCellLayout .nameLayout{
  float: right;
   width: 80%;
  vertical-align: center;
  justify-content: center;
  margin: auto 6px;
  font-size: 14px;
  color: #333;
}
.personSimpleCellLayout{
  display: flex;
  padding: 8px 10px 2px 12px;
  background-color: white;
}
.personSimpleCellLayout .portraitSimpleLayout{
  float: left;
  vertical-align: center;
  justify-content: center;
  width: 20%;
   margin: auto;
  text-align: center;
  font-size: 0.50rem;
  color: #64b572;
}
.personSimpleCellLayout .nameSimpleLayout{
  float: right;
  width: 80%;
  vertical-align: center;
  justify-content: center;
  margin: auto 6px;
  font-size: 12px;
  color: #333;
}
.singleLine{
  width: 100%;
  height: 1px;
  background-color: #f6f6f6;
}
.shiftSingleLine{
  width: 100%;
  height: 1px;
  margin-left: 12px;
  background-color: #f6f6f6;
}
.wideSingleLine{
  width: 100%;
  height: 3px;
  background-color: #f6f6f6;
}
.barLine{
  width: 100%;
  height: 8px;
  background-color: #f6f6f6;
}

</style>

<style lang="less">
  .yd-accordion{
      // box-shadow: 0px 0px 7px rgba(0,0,0,.2);
      background: #fff;
      border-radius: 10px;
      overflow: hidden;
  }
  .yd-accordion-head:after{
    height: 0;
  }
</style>